import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-offer-lc',
    templateUrl: './offer-lc.component.html',
    styleUrls: ['./offer-lc.component.scss'],
    standalone: false
})
export class OfferLcComponent implements OnInit {

  constructor() {
  }


  ngOnInit(): void {

  }

}
